export default {
  data() {
    return {
      selectedData: [],
    }
  },
  methods: {
    onSelectChange(selection) {
      this.selectedData = selection;
    },
    onDelete(rowData) {
      const deleteIds = rowData
        ? [rowData.id]
        : this.selectedData.map((item) => item.id);

      if (!deleteIds.length) {
        this.$message.error("请选择具体的描述");
        return;
      }

      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.doDelete(deleteIds);
      });
    },
    deleteSelection() {
      this.onDelete();
    },
    doDelete(deleteIds) {
      this.$q.product.delConfigDescribe({data: deleteIds})
      .then(({ code, message }) => {
        const isSuccess = code == 200;

        if (isSuccess) {
          this.$notify.success({
            title: "成功",
            message: `删除成功！`,
          });
        } else {
          this.$notify.error({
            title: "错误",
            message,
          });
        }

        if (isSuccess) {
          this.init();
        }
      });
    }
  }
}